import axios from 'axios';
import store from '../../store';

const domainAPI = store.state.domainAPI;

// Get Customer Dashboard Status
const cus_dashboardService_GetDashboardData = (data) =>
  axios.get(domainAPI + '/api/customer/dashboard', {
    headers: {
      Authorization: `Bearer ${data.token}`,
    },
  });

export { cus_dashboardService_GetDashboardData };
